import { useQuery } from '@tanstack/react-query';
import { userManagementApi } from '@/lib/api/user-management';
import { userManagementQueryKeys } from '@/lib/query-keys/userManagement';

export const useOrgMemberByIdQuery = (userId: string) => {
  return useQuery({
    queryKey: userManagementQueryKeys.userManagement.profile(userId),
    queryFn: async () => userManagementApi.getOrgUserById(userId),
    enabled: !!userId,
  });
};
